module.exports = __webpack_public_path__ + "img/wechat_qrcode.1570ea96.png";